var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErroneousDownIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10012 7.92978C6.88044 8.85661 8.29908 8.88228 9.11242 7.9843L15.5086 0.922482C15.7081 0.70224 15.6957 0.363126 15.4806 0.15811C15.2562 -0.0557604 14.8992 -0.0410261 14.6932 0.190608L9.11772 6.45981C8.30538 7.37323 6.87092 7.35067 6.0877 6.41216L0.88678 0.180012C0.676363 -0.0721264 0.284436 -0.0574055 0.0935279 0.209807C-0.0396575 0.396226 -0.0296058 0.649196 0.117952 0.824458L6.10012 7.92978Z",
    fill: "#5AC69F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErroneousDownIcon);
export default __webpack_public_path__ + "static/media/erroneous-down-icon.d21f4cc0ba291cf527f923b4c6e88af6.svg";
export { ForwardRef as ReactComponent };